const loadingLabel = "Loading";
const enAU = {
  loadingLabel
};
export {
  enAU as default,
  loadingLabel
};
